export const VEHICLE_CATALOG_ENTRY_STATUSES = ['active', 'hidden'];
export const VEHICLE_CATALOG_SOURCES = ['seed', 'staff', 'suggestion'];
export const VEHICLE_CATALOG_ALIAS_KINDS = ['spelling', 'ocr', 'rename', 'merge', 'seed'];
export const VEHICLE_CATALOG_SUGGESTION_KINDS = ['make', 'model'];
export const VEHICLE_CATALOG_SUGGESTION_STATUSES = [
    'pending',
    'accepted',
    'merged',
    'rejected',
];
export const VEHICLE_CATALOG_REJECT_REASONS = ['spam', 'typo', 'not_a_car', 'duplicate'];
export const VEHICLE_CATALOG_SUGGESTION_SOURCES = ['picker_report', 'order'];
/** Error codes of the admin catalogue endpoints (409 / 422 bodies). */
export const VEHICLE_CATALOG_ERROR_CODES = [
    'catalog_alias_conflict',
    'catalog_name_conflict',
    'catalog_stale_write',
    'catalog_name_too_long',
    // AUT-450 (VG-03) — (model, generation, restyling, market) is taken; details
    // `{generationId, status}` when the pre-check found it (a hidden row → «показать снова»).
    'catalog_generation_conflict',
    // AUT-871 (MOTO-03) — generations exist for cars only; a make / model / alias
    // of another vehicle kind than the one asked for.
    'generations_not_for_moto',
    'catalog_kind_mismatch',
];
// ─── AUT-450 (VG-03) — generations of a model ───────────────────────────────
export const VEHICLE_GENERATION_SOURCES = ['seed', 'staff'];
//# sourceMappingURL=admin-vehicle-catalog.js.map